<template>
  <v-container fluid style="padding: 0">
    <v-toolbar flat class="darken-2 elevation-5">
      <v-breadcrumbs :items="breads" large></v-breadcrumbs>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container fluid>
      <v-card>
        <v-card-title>进度详细信息</v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" sm="1" style="text-align: right">
                <span class="grey--text text--darken-1">名称:</span>
              </v-col>
              <v-col cols="12" sm="2">
                <span>{{ data.progressname }}</span>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="1" style="text-align: right">
                <span class="grey--text text--darken-1">详细要求:</span>
              </v-col>
              <v-col cols="12" sm="4">
                <span>{{ data.requirement }}</span>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="1" style="text-align: right">
                <span class="grey--text text--darken-1">状态:</span>
              </v-col>
              <v-col cols="12" sm="2">
                <span>{{ data.status }}</span>
              </v-col>
              <v-col cols="12" sm="1" style="text-align: right">
                <span class="grey--text text--darken-1">预计完成时间:</span>
              </v-col>
              <v-col cols="12" sm="2">
                <span>{{ data.estimate | moment("YYYY-MM-DD") }}</span>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="1" style="text-align: right">
                <span class="grey--text text--darken-1">备注:</span>
              </v-col>
              <v-col cols="12" sm="11">
                <span>{{ data.note }}</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-sheet outlined>
          <v-tabs background-color="blue-grey lighten-5">
            <v-tab>文档</v-tab>
            <v-tab-item>
              <document-tab :parentid="id" parenttype="progress"></document-tab>
            </v-tab-item>
          </v-tabs>
        </v-sheet>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    loading: false,
    breads: [
      {
        text: "项目管理",
        disabled: false,
        to: "/",
      },
      {
        text: "",
        disabled: false,
      },
      {
        text: "",
        disabled: false,
      },
      {
        text: "",
        disabled: true,
      },
    ],
    data: {},
  }),
  watch: {
    id: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$hc
        .req()
        .get(`progress/${this.id}`)
        .go({
          lock: true,
          toastError: true,
          toastSuccess: "",
        })
        .subscribe(
          (x) => {
            this.loading = false;
            this.data = x.Data;
            this.breads[1].text = this.data.projectname;
            this.breads[1].to = `/projects/${this.data.projectid}/details`;
            this.breads[2].text = this.data.subprojectname;
            this.breads[2].to = `/subprojects/${this.data.subprojectid}/details`;
            this.breads[3].text = this.data.progressname;
          },
          (x) => {}
        );
    },
  },
};
</script>
